( function( $ ) {